import { render, staticRenderFns } from "./LoginTemplateComponent.vue?vue&type=template&id=f650e8d0&scoped=true"
import script from "./LoginTemplateComponent.vue?vue&type=script&lang=js"
export * from "./LoginTemplateComponent.vue?vue&type=script&lang=js"
import style0 from "./LoginTemplateComponent.vue?vue&type=style&index=0&id=f650e8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f650e8d0",
  null
  
)

export default component.exports